import { Button } from '@mui/material';
import { HeroWidget as ComponentLibraryHeroWidget } from '@orcha/micro-library-widgets-ui';
import HeroDefaultBackground from 'public/heroBackground.jpg';
import { SearchAutocomplete } from 'src/components/Search';
import { SearchProvider } from 'src/store';
import { logEventAnalytic } from 'src/utilities/logAnalytics';
import theme from 'src/themes/theme';
import { truncateText } from 'src/utilities/stringFormat';
import { useRouter } from 'next/router';
import { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import { HeroWidgetProps } from './HeroWidget.types';
import { ButtonsContainer, SearchContainer } from './HeroWidget.styles';

const HeroWidget = (props: HeroWidgetProps) => {
  const { title, subtitle, search, backgroundImageUrl } = props;
  const { t } = useTranslation('search');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { placeholderText, buttonText } = search || {};

  const router = useRouter();
  const backgroundImageSrc =
    backgroundImageUrl && backgroundImageUrl?.length !== 0
      ? backgroundImageUrl
      : HeroDefaultBackground.src;

  const invokeSearch = () => {
    logEventAnalytic({
      category: 'Search',
      action: 'Searched for an app using the search bar - microsite',
      label: `${searchTerm}`,
    });

    router.push({
      pathname: '/search',
      query: { search: searchTerm },
    });
  };

  return (
    <ComponentLibraryHeroWidget
      FlexibleImageComponent={Image}
      title={title}
      subtitle={subtitle}
      backgroundImageUrl={backgroundImageSrc}
    >
      {search?.isHidden === true ? (
        <></>
      ) : (
        <SearchProvider>
          <SearchContainer>
            <SearchAutocomplete
              placeholderText={
                placeholderText && placeholderText?.length > 0
                  ? search?.placeholderText
                  : undefined
              }
              onInputChanged={setSearchTerm}
              onFreeTextSubmit={invokeSearch}
            />
            <ButtonsContainer>
              <Button
                color="primary"
                data-testid="search-button"
                variant="contained"
                onClick={invokeSearch}
                fullWidth
                sx={{
                  [theme.breakpoints.up('sm')]: {
                    minWidth: '180px',
                  },
                }}
              >
                {buttonText && buttonText?.length > 0
                  ? truncateText(buttonText, 35)
                  : t('searchButton')}
              </Button>
            </ButtonsContainer>
          </SearchContainer>
        </SearchProvider>
      )}
    </ComponentLibraryHeroWidget>
  );
};

export default HeroWidget;
